
//用户接口相关的函数
import request from "@/untils/request.js"

/**
 * 
 * @param { post } data 
 *  
 */

// 积分张林 新增积分健康档案人员分类
export const addPhrType = (data) => {
    return request.post("/outpatient/pointPhrType/addPhrType", data)
}

// 积分张林 修改积分健康档案人员分类
export const editPhrType = (data) => {
    return request.post("/outpatient/pointPhrType/editPhrType", data)
}

// 积分张林 分页查询积分生成规则
export const pointList = (data) => {
    return request.post("/outpatient/point/pageList", data)
}

// 积分张林 新增分页查询积分生成规则
export const addPointsRule = (data) => {
    return request.post("/outpatient/point/addRule", data)
}

// 积分张林 修改分页查询积分生成规则
export const editPointsRule = (data) => {
    return request.post("/outpatient/point/editRule", data)
}

// 积分张林 查询积分健康档案人员信息
export const pageList = (data) => {
    return request.post("/outpatient/point_person/pageList", data)
}

// 积分扣减张林 查询积分扣减列表信息-分页
export const reduceList = (data) => {
    return request.post("/outpatient/point_reduce/reduceList", data)
}

// 积分扣减张林 新增积分扣减
export const addReduce = (data) => {
    return request.post("/outpatient/point_reduce/addReduce", data)
}

/**
 * 
 * @param { get } params 
 *  
 */

// 积分张林 查询积分扣减业务来源
export const point_souc = (params) => {
    return request.get("/outpatient/point_reduce/point_souc", { params })
}


// 积分张林 更新积分规则状态
export const updatePointsRule = (params) => {
    return request.get("/outpatient/point/updateState", { params })
}

// 积分张林 查询积分生成规则详情
export const pointsRuleDetails = (params) => {
    return request.get("/outpatient/point/detailPointRule", { params })
}

// 积分张林 查询积分健康档案人员分类详情信息
export const pointPhrTypeDetail = (params) => {
    return request.get("/outpatient/pointPhrType/detail", { params })
}

// 积分张林 查询当前诊所下所有积分健康档案人员分类
export const listAll = (params) => {
    return request.get("/outpatient/pointPhrType/listAll", { params })
}

// 积分张林 查询当前诊所下所有积分健康档案人员分类和名称信息-选择使用 下拉列表
export const listSelectAll = (params) => {
    return request.get("/outpatient/pointPhrType/listSelectAll", { params })
}

// 积分张林 删除积分生成规则
export const deleteRule = (params) => {
    return request.delete("/outpatient/point/deleteRule", { params })
}

// 积分张林 查询积分变更明细信息-分页
export const chgDetail = (params) => {
    return request.get("/outpatient/point_person/chg_detail", { params })
}

// 积分张林 更新积分健康档案人员分类
export const updateType = (params) => {
    return request.get("/outpatient/point_person/updateType", { params })
}

// 暴露
export default{

}